export const FETCH_EVENTS = 'FETCH_EVENTS';
export const FETCH_ACTIVE_EVENTS = 'FETCH_ACTIVE_EVENTS';
export const FETCH_EVENT = 'FETCH_EVENT';
export const FETCH_REASONS_TO_ATTEND = 'FETCH_REASONS_TO_ATTEND';
export const FETCH_VENUE = 'FETCH_VENUE';
export const FETCH_VENUE_CITY_IMAGES = 'FETCH_VENUE_CITY_IMAGES';
export const KNOWLEDGE_SHARING_SESSION = 'KNOWLEDGE_SHARING_SESSION';
export const STRATEGIC_SPONSORS = 'STRATEGIC_SPONSORS';
export const PARALLEL_EVENTS = 'PARALLEL_EVENTS';
export const ACCOMMODATIONS = 'ACCOMMODATIONS';
export const SPEAKERS_LIST = 'SPEAKERS_LIST';
export const EXHIBITORS = 'EXHIBITORS';
export const BOOKED_TABLES = 'BOOKED_TABLES';
export const MEDIA = 'MEDIA';
export const MEETING_ROOMS = 'MEETING_ROOMS';
export const PARTICIPANT_MEMBERS = 'PARTICIPANT_MEMBERS';
export const EVENT_PRICES = 'EVENT_PRICES';
export const AWARD_PRICES = 'AWARD_PRICES';
export const PARTICIPANT_COMPANIES = 'PARTICIPANT_COMPANIES';
export const FETCH_PREVIOUS_EDITION = 'FETCH_PREVIOUS_EDITION';
export const FETCH_EVENT_ALL_SPONSORS = 'FETCH_EVENT_ALL_SPONSORS';
